import React, { useCallback, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Col, notification, Row, Tabs } from 'antd';

import { Empty } from '../../layouts/index';

import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './UpdatePassword';
import TitleLogo from './TitleLogo';
import { forgot, reset } from '../../services/users';

const ForgotPassword = () => {
  const history = useHistory();
  const { token } = useParams();
  const { t } = useTranslation();

  const [errors, setErrors] = useState(null);

  const handleSubmit = useCallback(
    (value) => {
      (token
        ? reset(token, value).then(() => {
            notification.success({
              message: t('messages.password.changed'),
              duration: 5000,
            });
            setTimeout(() => history.push('/'), 5000);
          })
        : forgot(value).then(() => {
            notification.success({
              message: t('messages.password.reset'),
              duration: 5000,
            });
            setTimeout(() => history.push('/'), 5000);
          })
      ).catch((err) => {
        setErrors(err?.inner || {});
        notification.error({
          message: t('Eroare la resetare'),
        });
      });
    },
    [history, t, token],
  );

  const handleCancel = useCallback(() => {
    history.push('/');
  }, [history]);

  return (
    <Empty>
      <TitleLogo />
      <Row>
        <Col
          style={{
            backgroundColor: 'rgba(255, 255, 255, .7)',
            padding: '1rem',
          }}
          xs={{ span: 24 }}
          sm={{ span: 16, offset: 4 }}
          md={{ span: 12, offset: 6 }}
          lg={{ span: 8, offset: 8 }}
          xl={{ span: 6, offset: 9 }}
        >
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab={t('actions.resetPassword')} key="1">
              {token ? (
                <ResetPasswordForm
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  errors={errors}
                />
              ) : (
                <ForgotPasswordForm
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  errors={errors}
                />
              )}
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
    </Empty>
  );
};

export default ForgotPassword;
